import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Shield Check icon with gradient fill
 */
export const ShieldCheckGradient: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 12.9988C20 17.9988 16.5 20.4988 12.34 21.9488C12.1222 22.0226 11.8855 22.0191 11.67 21.9388C7.5 20.4988 4 17.9988 4 12.9988V5.9988C4 5.73359 4.10536 5.47923 4.29289 5.2917C4.48043 5.10416 4.73478 4.9988 5 4.9988C7 4.9988 9.5 3.7988 11.24 2.2788C11.4519 2.0978 11.7214 1.99835 12 1.99835C12.2786 1.99835 12.5481 2.0978 12.76 2.2788C14.51 3.8088 17 4.9988 19 4.9988C19.2652 4.9988 19.5196 5.10416 19.7071 5.2917C19.8946 5.47923 20 5.73359 20 5.9988V12.9988Z"
      fill="url(#paint0_linear_331_1253)"
      stroke="#472695"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.9988L11 13.9988L15 9.99878"
      fill="url(#paint1_linear_331_1253)"
    />
    <path
      d="M9 11.9988L11 13.9988L15 9.99878"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_331_1253"
        x1="7.75"
        y1="4.25006"
        x2="19.3836"
        y2="8.19667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#763FF9" />
        <stop offset="1" stopColor="#FF0174" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_331_1253"
        x1="9"
        y1="9.99878"
        x2="15.5066"
        y2="11.0795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#763FF9" />
        <stop offset="1" stopColor="#FF0174" />
      </linearGradient>
    </defs>
  </svg>
);
